export enum DispatchStatus {
  Dispatched = 1, // 派遣中
  ReturningWithLoots = 2, // 返回中
  Returned = 3, // 已返回
  Settled = 4, // 已结算
  Failed = 5, // 失败
  Preparing = 6, // 准备中
  AwaitingInviteeResponse = 7, // 等待邀请者响应
  Canceled = 8, // 已取消
}

export enum DispatchDuration {
  Minutes5 = 5,
  Minutes2 = 2,
  Minutes4 = 4,
  Minutes6 = 6,
  Minutes8 = 8,
  Minutes10 = 10,
  Minutes12 = 12,
}

export enum EquipmentStatus {
  ToBeDelivered = 1,
  Active = 2,
  Discarded = 3,
}

export enum EquipmentRarity {
  Common = 1, // 普通
  Rare = 2, // 罕见
  Epic = 3, // 稀有
  Legendary = 4, // 传说
}

export enum EquipmentType {
  Item = 1,
  Chest = 2,
}

export enum MateInteractionStatus {
  Idle = 1,
  Dispatched = 2,
  DispatchedAwaitingPickup = 3,
  Strolling = 4,
  PreparingDispatch = 5,
}

export enum DispatchType {
  Stroll = 1,
  Mission = 2,
}

export enum InvitationType {
  Stroll = 1,
  Mission = 2,
  Friend = 3,
}

export enum InteractionEventType {
  // 加入互动池
  JoinedInteractionPool = 1,
  // 离开互动池
  LeftInteractionPool = 2,
  // 请求溜达
  RequestStroll = 3,
  // 请求写信
  RequestLetterSending = 4,
  // 溜达派遣
  StrollDispatched = 5,
  // 溜达返回
  StrollReturned = 6,
  // 写信发送
  LetterSent = 7,
  // 收到信
  ReceivedLetter = 8,
  // 拉黑
  BlockedMate = 9,
  // 取消拉黑
  UnblockedMate = 10,
  // 好友邀请发送
  FriendInvitationSent = 11,
  // 好友邀请批准
  FriendInvitationApproved = 12,
  // 好友邀请拒绝
  FriendInvitationRejected = 13,
  // 收到好友邀请
  ReceivedLetterFriendInvitation = 14,
  // 任务邀请发送
  MissionInvitationSent = 15,
  // 任务邀请批准
  MissionInvitationApproved = 16,
  // 任务邀请拒绝
  MissionInvitationRejected = 17,
  // 收到任务邀请
  ReceivedMissionInvitation = 18,
  // 离开任务
  LeftMission = 19,
  // 任务返回
  MissionReturned = 20,
  // 任务派遣
  DispatchedMission = 21,
  // 请求发布动态
  RequestMomentPost = 22,
  // 请求评论动态
  RequestMomentComment = 23,
  // 请求执行任务
  RequestMission = 24,
}

export enum InteractionEventEntityType {
  MateInvitation = "App\\Models\\MateInvitation",
  MateDispatch = "App\\Models\\MateDispatch",
  MateMail = "App\\Models\\MateMail",
  MateRelationship = "App\\Models\\MateRelationship",
}

export enum MateInvitationEntityType {
  Mate = "mate",
  MateDispatch = "mateDispatch",
}

export enum InvitationStatus {
  Draft = 1,
  Pending = 2,
  Accepted = 3,
  Rejected = 4,
  Cancelled = 5,
}

export enum InteractionEventStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export enum MailSenderStatus {
  Draft = 1,
  Sent = 2,
  Trashed = 3,
  Deleted = 4,
}

export enum MailRecipientStatus {
  Unavailable = 1,
  Inbox = 2,
  Spam = 3,
  Trashed = 4,
  Deleted = 5,
}

export enum RelationshipType {
  Acquaintance = 1,
  Friend = 2,
  CustomRelationship = 3,
}
export enum MateDispatchStatusRequest {
  Preparing = "preparing",
  Dispatched = "dispatched",
  Returned = "returned",
  Settled = "settled",
  Canceled = "canceled",
}

export enum DispatchDifficultyLevel {
  Easy = 1,
  Medium = 2,
  Hard = 3,
  Nightmare = 4,
  Hell = 5,
}

export enum AgentType {
  Direct = 1,
  GM = 2,
  Character = 3,
  Writer = 4,
}

export enum MessageRole {
  User = "user",
  Assistant = "assistant",
  Text = "text",
}

export enum GateStatus {
  Open = 1,
  Silent = 0,
}
